import React, { useState } from 'react';
import { getTranslatedText } from '@nile/components';
import styled from 'styled-components';

function HiddenActions(props) {
  const { showCc, showBcc, intl } = props;
  const [ccVisible, setCcVisible] = useState(showCc);
  const [bccVisible, setBccVisible] = useState(showBcc);
  const handleCc = () => {
    setCcVisible(true);
    props.updateState('showCc', true);
  };

  const handleBcc = () => {
    setBccVisible(true);
    props.updateState('showBcc', true);
  };

  return (
    <div className="flex center mlauto">
      {!ccVisible && (
        <div className="text-medium mr-12 cursor-pointer" onClick={handleCc}>
          {getTranslatedText(intl, 'app.mail.recepients.cc')}
        </div>
      )}
      {!bccVisible && (
        <div className="text-medium mr-12 cursor-pointer" onClick={handleBcc}>
          {getTranslatedText(intl, 'app.mail.recepients.bcc')}
        </div>
      )}
    </div>
  );
}

/**
 * Override react-mentions style.
 * This is used in all email templates
 */
const MentionsHolder = styled.div.attrs({
  className: 'mt20'
})`
  input {
    &:focus {
      border: 2px inset transparent;
      outline: none;
    }

    &::placeholder {
      color: #000000;
      opacity: 0.4;
    }

    &:-ms-input-placeholder {
      color: #0000004d;
    }

    &::-ms-input-placeholder {
      color: #0000004d;
    }
  }
`;

export { HiddenActions, MentionsHolder };
